import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonFr from './translations/fr/common.json';
import frontFr from './translations/fr/front.json';
import boFr from './translations/fr/back-office.json';
import commonEn from './translations/en/common.json';
import frontEn from './translations/en/front.json';
import boEn from './translations/en/back-office.json';
import commonDe from './translations/de/common.json';
import frontDe from './translations/de/front.json';
import boDe from './translations/de/back-office.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    interpolation: {
      escapeValue: false,
    }, // React already does escaping
    // lng: 'fr',
    fallbackLng: 'en',
    defaultNS: 'common',
    react: {
      useSuspense: false,
    },
    resources: {
      fr: {
        common: commonFr,
        'back-office': boFr,
        front: frontFr,
      },
      en: {
        common: commonEn,
        'back-office': boEn,
        front: frontEn,
      },
      de: {
        common: commonDe,
        'back-office': boDe,
        front: frontDe,
      },
    },
  });

export default i18n;
